import {AnimalTypes} from "../constans/animalTypes";
import {EventCategory} from "../constans/eventTypes";
import {eventChooserFormNames} from "../constans/formNames";
import formDataDB from "../database/formDataDB";
import sow from "../resources/images/animal-kind-chooser/sow.svg";
import active_nipples from "../resources/images/events/active_nipples.svg";
import castration from "../resources/images/events/castration.svg";
import comments from "../resources/images/events/comments.svg";
import fallPiglets from "../resources/images/events/fall-piglets.svg";
import fall from "../resources/images/events/fall.svg";
import grafting from "../resources/images/events/grafting.svg";
import heat from "../resources/images/events/heat.svg";
import insemination from "../resources/images/events/insemination.svg";
import insertion from "../resources/images/events/insertion.svg";
import lost from "../resources/images/events/lost-rfid.svg";
import noPregnancy from "../resources/images/events/no-pregnancy.svg";
import parturition from "../resources/images/events/parturition.svg";
import tagging from "../resources/images/events/pig-number.svg";
import piglets_treatment from "../resources/images/events/piglets_treatment.svg";
import reclassify from "../resources/images/events/reclassify.svg";
import selection from "../resources/images/events/selection.svg";
import sell from "../resources/images/events/sell.svg";
import separationMommy from "../resources/images/events/separation-mommy.svg";
import separationPorkhouse from "../resources/images/events/separation-porkhouse.svg";
import tattoo from "../resources/images/events/tattoo.svg";
import transfer from "../resources/images/events/transfer.svg";
import treatment from "../resources/images/events/treatment.svg";
import usg from "../resources/images/events/usg.svg";
import weightSVG from "../resources/images/events/weightSVG.svg";
import {checkIfUserIsService} from "./NewRolesUtils";

export function getEventsList(t, FarmID, animalKind) {
    return [
        {
            label: t("insertion"),
            value: "animalKind/insertion",
            svgPath: insertion,
            eligibleAnimal: [
                AnimalTypes.SOW,
                AnimalTypes.BOAR,
                AnimalTypes.PIGLET,
                AnimalTypes.PORKER,
                AnimalTypes.RENOVATION_SOW,
            ],
            category: EventCategory.OVERALL,
            drafts: formDataDB.getDraftsBeginsWith(
                [
                    eventChooserFormNames.INSERTION + "_" + animalKind,
                    eventChooserFormNames.INSERTION + "_" + -animalKind,
                ],
                FarmID
            ),
        },
        {
            label: t("insemination"),
            value: "insemination",
            svgPath: insemination,
            eligibleAnimal: [AnimalTypes.SOW, AnimalTypes.RENOVATION_SOW],
            category: EventCategory.PROCREATION,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.INSEMINATION + "_" + animalKind],
                FarmID
            ),
        },
        {
            label: t("usg"),
            value: "usg",
            svgPath: usg,
            eligibleAnimal: [AnimalTypes.SOW],
            category: EventCategory.PROCREATION,
            drafts: formDataDB.getDrafts([eventChooserFormNames.USG], FarmID),
        },
        {
            label: t("noPregnancy"),
            value: "noPregnancy",
            svgPath: noPregnancy,
            eligibleAnimal: [AnimalTypes.SOW],
            category: EventCategory.PROCREATION,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.NO_PREGNANCY],
                FarmID
            ),
        },
        {
            label: t("parturition"),
            value: "parturition",
            svgPath: parturition,
            eligibleAnimal: [AnimalTypes.SOW],
            category: EventCategory.PARTURITION,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.PARTURITION],
                FarmID
            ),
        },
        {
            label: t("apiNotifications.deliverySettlementTitle"),
            value: "parturitionState",
            svgPath: parturition,
            eligibleAnimal: [AnimalTypes.SOW],
            category: EventCategory.PARTURITION,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.PARTURITION_STATE],
                FarmID
            ),
        },
        {
            label: t("separationToPigletHouse"),
            value: "separationToPigletHouse",
            svgPath: separationPorkhouse,
            eligibleAnimal: [AnimalTypes.SOW],
            category: EventCategory.PARTURITION,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.SEPARATION_TO_PORKHOUSE],
                FarmID
            ),
        },
        {
            label: t("separationToBabyRoom"),
            value: "separationToBabyRoom",
            svgPath: separationPorkhouse,
            eligibleAnimal: [AnimalTypes.SOW],
            category: EventCategory.BABY_ROOM,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.SEPARATION_TO_BABY_ROOM],
                FarmID
            ),
        },
        {
            label: t("separationFromBabyRoom"),
            value: "type?next=locationChooser/separationFromBabyRoom",
            svgPath: transfer,
            eligibleAnimal: [AnimalTypes.SOW, AnimalTypes.PIGLET],
            category: EventCategory.BABY_ROOM,
            drafts: formDataDB.getDraftsBeginsWith(
                [
                    eventChooserFormNames.SEPARATION_FROM_BABY_ROOM +
                        "_" +
                        AnimalTypes.PIGLET,
                ],
                FarmID
            ),
        },
        {
            label: t("giltsSeparation"),
            value: "giltsSeparation",
            svgPath: separationPorkhouse,
            eligibleAnimal: [AnimalTypes.SOW],
            category: EventCategory.GILTS,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.GILTS_SEPARATION],
                FarmID
            ),
        },
        {
            label: t("separationToMommy"),
            value: "separationToMommy",
            svgPath: separationMommy,
            eligibleAnimal: [AnimalTypes.SOW],
            category: EventCategory.PARTURITION,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.SEPARATION_TO_MOMMY],
                FarmID
            ),
        },
        {
            label: t("separationGiltsToMommy"),
            value: "separationGiltsToMommy",
            svgPath: separationMommy,
            eligibleAnimal: [AnimalTypes.SOW],
            category: EventCategory.GILTS,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.SEPARATION_TO_MOMMY_GILTS],
                FarmID
            ),
        },
        {
            label: t("reportTreatment"),
            value: "grafting",
            svgPath: grafting,
            eligibleAnimal: [AnimalTypes.BOAR],
            category: EventCategory.GRAFTING,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.GRAFTING + "_" + animalKind],
                FarmID
            ),
        },
        {
            label: t("reportTreatment"),
            value: "type?next=graftingSow",
            svgPath: grafting,
            eligibleAnimal: [AnimalTypes.SOW, AnimalTypes.RENOVATION_SOW],
            category: EventCategory.GRAFTING,
            drafts: formDataDB.getDrafts(
                [
                    eventChooserFormNames.GRAFTING + "_" + animalKind,
                    eventChooserFormNames.GRAFTING_LOCATION + "_" + animalKind,
                ],
                FarmID
            ),
        },
        {
            label: t("reportTreatment"),
            value: `type?next=grafting${
                animalKind === AnimalTypes.PORKER ? "Porker" : "Piglet"
            }`,
            svgPath: grafting,
            eligibleAnimal: [AnimalTypes.PIGLET, AnimalTypes.PORKER],
            category: EventCategory.GRAFTING,
            drafts: formDataDB.getDrafts(
                [
                    eventChooserFormNames.GRAFTING + "_" + animalKind,
                    eventChooserFormNames.GRAFTING_LOCATION + "_" + animalKind,
                ],
                FarmID
            ),
        },
        {
            label: t("scheduleOfTreatment"),
            value: "scheduleOfTreatment",
            svgPath: treatment,
            eligibleAnimal: [
                AnimalTypes.SOW,
                AnimalTypes.BOAR,
                AnimalTypes.RENOVATION_SOW,
            ],
            category: EventCategory.GRAFTING,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.TREATMENT + "_" + animalKind],
                FarmID
            ),
        },
        {
            label: t("scheduleOfTreatment"),
            value: `type?next=scheduleOfTreatment${
                animalKind === AnimalTypes.PORKER ? "Porker" : "Piglet"
            }`,
            svgPath: treatment,
            eligibleAnimal: [AnimalTypes.PIGLET, AnimalTypes.PORKER],
            category: EventCategory.GRAFTING,
            drafts: formDataDB.getDrafts(
                [
                    eventChooserFormNames.TREATMENT + "_" + animalKind,
                    eventChooserFormNames.TREATMENT_LOCATION + "_" + animalKind,
                ],
                FarmID
            ),
        },
        {
            label: t("fallPiglets"),
            value: "fallPiglets",
            svgPath: fallPiglets,
            eligibleAnimal: [AnimalTypes.SOW],
            category: EventCategory.FALL,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.FALL_PIGLETS],
                FarmID
            ),
        },
        {
            label: t("fallTattooedPiglets"),
            value: "fallTattooedPiglets",
            svgPath: fallPiglets,
            eligibleAnimal: [AnimalTypes.SOW],
            category: EventCategory.GILTS,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.FALL_TATTOOED_PIGLETS],
                FarmID
            ),
        },
        {
            label: t("transfer"),
            value: "locationChooser/transfer",
            svgPath: transfer,
            eligibleAnimal: [AnimalTypes.SOW, AnimalTypes.BOAR],
            category: EventCategory.OVERALL,
            drafts: formDataDB.getDraftsBeginsWith(
                [
                    eventChooserFormNames.TRANSFER_STAND + "_" + animalKind,
                    eventChooserFormNames.TRANSFER_CHAMBER + "_" + animalKind,
                ],
                FarmID
            ),
        },
        {
            label: t("transfer"),
            value: "type?next=locationChooser/transfer",
            svgPath: transfer,
            eligibleAnimal: [
                AnimalTypes.PIGLET,
                AnimalTypes.RENOVATION_SOW,
                AnimalTypes.PORKER,
            ],
            category: EventCategory.OVERALL,
            drafts: formDataDB.getDraftsBeginsWith(
                [
                    eventChooserFormNames.TRANSFER_STAND + "_" + animalKind,
                    eventChooserFormNames.TRANSFER_CHAMBER + "_" + animalKind,
                ],
                FarmID
            ),
        },
        {
            label: t("fall"),
            value: "fall",
            svgPath: fall,
            eligibleAnimal: [
                AnimalTypes.RENOVATION_SOW,
                AnimalTypes.SOW,
                AnimalTypes.BOAR,
            ],
            category: EventCategory.FALL,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.FALL + "_" + animalKind],
                FarmID
            ),
        },
        {
            label: t("fall"),
            value: `type?next=fall${
                animalKind === AnimalTypes.PORKER ? "Porker" : "Piglet"
            }`,
            svgPath: fall,
            eligibleAnimal: [AnimalTypes.PIGLET, AnimalTypes.PORKER],
            category: EventCategory.FALL,
            drafts: formDataDB.getDrafts(
                [
                    eventChooserFormNames.FALL + "_" + animalKind,
                    eventChooserFormNames.FALL_LOCATION + "_" + animalKind,
                ],
                FarmID
            ),
        },
        {
            label: t("fallBabyRoom"),
            value: "type?next=fallBabyRoom",
            svgPath: fall,
            eligibleAnimal: [AnimalTypes.SOW, AnimalTypes.PIGLET],
            category: EventCategory.FALL,
            drafts: formDataDB.getDrafts(
                [
                    eventChooserFormNames.FALL_BABY_ROOM +
                        "_" +
                        AnimalTypes.PIGLET,
                    eventChooserFormNames.FALL_BABY_ROOM_LOCATION +
                        "_" +
                        AnimalTypes.PIGLET,
                ],
                FarmID
            ),
        },
        {
            label: t("sale"),
            value: "sale",
            svgPath: sell,
            eligibleAnimal: [
                AnimalTypes.RENOVATION_SOW,
                AnimalTypes.SOW,
                AnimalTypes.BOAR,
            ],
            category: EventCategory.SELL,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.SELL + "_" + animalKind],
                FarmID
            ),
        },
        {
            label: t("sale"),
            value: "type?next=sale",
            svgPath: sell,
            eligibleAnimal: [AnimalTypes.PIGLET, AnimalTypes.PORKER],
            category: EventCategory.SELL,
            drafts: formDataDB.getDrafts(
                [
                    eventChooserFormNames.SELL + "_" + animalKind,
                    eventChooserFormNames.SELL_LOCATION + "_" + animalKind,
                ],
                FarmID
            ),
        },
        {
            label: t("selection"),
            value: "selection",
            svgPath: selection,
            eligibleAnimal: [
                AnimalTypes.RENOVATION_SOW,
                AnimalTypes.SOW,
                AnimalTypes.BOAR,
            ],
            category: EventCategory.SELL,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.SELECTION + "_" + animalKind],
                FarmID
            ),
        },
        {
            label: t("weighting"),
            value: "weighting",
            svgPath: weightSVG,
            eligibleAnimal: [
                AnimalTypes.RENOVATION_SOW,
                AnimalTypes.SOW,
                AnimalTypes.BOAR,
            ],
            category: EventCategory.OVERALL,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.WEIGHTING + "_" + animalKind],
                FarmID
            ),
        },
        {
            label: t("weighting"),
            value: `type?next=weighting${
                animalKind === AnimalTypes.PORKER ? "Porker" : "Piglet"
            }`,
            svgPath: weightSVG,
            category: EventCategory.OVERALL,
            drafts: formDataDB.getDrafts(
                [
                    eventChooserFormNames.WEIGHTING + "_" + animalKind,
                    eventChooserFormNames.WEIGHTING_LOCATION + "_" + animalKind,
                ],
                FarmID
            ),
            eligibleAnimal: [AnimalTypes.PIGLET, AnimalTypes.PORKER],
        },
        {
            label: t("activeNipples"),
            value: "activeNipples",
            svgPath: active_nipples,
            eligibleAnimal: [AnimalTypes.SOW, AnimalTypes.RENOVATION_SOW],
            category: EventCategory.PARTURITION,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.ACTIVE_NIPPLES],
                FarmID
            ),
        },
        {
            label: t("reclassify"),
            value: "type?next=reclassify",
            svgPath: reclassify,
            eligibleAnimal: [AnimalTypes.PIGLET, AnimalTypes.PORKER],
            category: EventCategory.OVERALL,
            drafts: formDataDB.getDrafts(
                [
                    eventChooserFormNames.RECLASSIFY + "_" + animalKind,
                    eventChooserFormNames.RECLASSIFY_LOCATION +
                        "_" +
                        animalKind,
                ],
                FarmID
            ),
        },
        {
            label: t("reclassify"),
            value: "reclassifySow",
            svgPath: reclassify,
            eligibleAnimal: [AnimalTypes.SOW, AnimalTypes.RENOVATION_SOW],
            category: EventCategory.GILTS,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.RECLASSIFY_SOW + "_" + animalKind],
                FarmID
            ),
        },
        {
            label: t("pigletsMedication"),
            value: "pigletsMedication",
            svgPath: piglets_treatment,
            eligibleAnimal: [AnimalTypes.SOW],
            category: EventCategory.PIGLETS,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.PIGLETS_TREATMENT],
                FarmID
            ),
        },
        {
            label: t("heat"),
            value: "heat",
            svgPath: heat,
            eligibleAnimal: [AnimalTypes.RENOVATION_SOW, AnimalTypes.SOW],
            category: EventCategory.PROCREATION,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.HEAT + "_" + animalKind],
                FarmID
            ),
        },
        {
            label: t("lostEarring"),
            value: "lostEarring",
            svgPath: lost,
            eligibleAnimal: [
                AnimalTypes.RENOVATION_SOW,
                AnimalTypes.SOW,
                AnimalTypes.PIGLET,
                AnimalTypes.BOAR,
                AnimalTypes.PORKER,
            ],
            category: EventCategory.OVERALL,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.LOST_EARRING + "_" + animalKind],
                FarmID
            ),
        },
        {
            label: t("dosatron"),
            value: "dosatron/chooser",
            svgPath: grafting,
            eligibleAnimal: [
                AnimalTypes.SOW,
                AnimalTypes.PIGLET,
                AnimalTypes.BOAR,
                AnimalTypes.PORKER,
                AnimalTypes.RENOVATION_SOW,
            ],
            category: EventCategory.GRAFTING,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.DOSATRON + "_" + animalKind],
                FarmID
            ),
        },
        {
            label: t("pigletsTreatment"),
            value: "pigletsTreatment",
            svgPath: castration,
            eligibleAnimal: [AnimalTypes.SOW],
            category: EventCategory.PIGLETS,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.CASTRATION],
                FarmID
            ),
        },
        {
            label: t("tattooing"),
            value: "tattoo",
            svgPath: tattoo,
            eligibleAnimal: [AnimalTypes.SOW],
            category: EventCategory.PARTURITION,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.TATTOO + "_" + animalKind],
                FarmID
            ),
        },
        {
            label: t("fatMeasurement"),
            value: "fatMeasurement",
            svgPath: sow,
            eligibleAnimal: [AnimalTypes.SOW],
            category: EventCategory.OVERALL,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.FAT_MEASUREMENT],
                FarmID
            ),
        },
        {
            label: t("printSelectedAnimalsModal.comments"),
            value: "comments",
            svgPath: comments,
            eligibleAnimal: [
                AnimalTypes.SOW,
                AnimalTypes.BOAR,
                AnimalTypes.PIGLET,
                AnimalTypes.PORKER,
                AnimalTypes.RENOVATION_SOW,
            ],
            category: EventCategory.OVERALL,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.COMMENTS + "_" + animalKind],
                FarmID
            ),
        },
        {
            label: t("tagging"),
            value: "type?next=tagging",
            svgPath: tagging,
            eligibleAnimal: [AnimalTypes.PIGLET, AnimalTypes.PORKER],
            category: EventCategory.OVERALL,
            drafts: formDataDB.getDrafts(
                [
                    eventChooserFormNames.TAGGING + "_" + animalKind,
                    eventChooserFormNames.TAGGING_LOCATION + "_" + animalKind,
                ],
                FarmID
            ),
        },
        {
            label: t("eventTypes.W"),
            value: "locationChooser/isMommy",
            svgPath: tagging,
            eligibleAnimal: [AnimalTypes.RENOVATION_SOW, AnimalTypes.SOW],
            category: EventCategory.PARTURITION,
            drafts: formDataDB.getDrafts(
                [eventChooserFormNames.IS_MOMMY],
                FarmID
            ),
            show: checkIfUserIsService(),
        },
    ];
}
